import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2dcb2cba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2dcb2cba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb2cba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcb2cba')) {
      api.createRecord('2dcb2cba', component.options)
    } else {
      api.reload('2dcb2cba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2dcb2cba&scoped=true", function () {
      api.rerender('2dcb2cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/index.vue"
export default component.exports